module.exports = __webpack_public_path__ + "static/media/stv1.ac1ec7e1.mp3";